import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import CartPromoManager from '@/components/v2/CartPromoManager.vue';
import ActionButton from '@/components/action_button/Index.vue';
import { PromoType } from '@/helpers/entities/enums/v2/PromoType';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let CartPromos = class CartPromos extends Mixins(ViewportSizeMixin, CleverTapEventsMixin) {
    get headers() {
        return [
            {
                text: 'REQUIRED AMOUNT',
                value: 'requiredAmount',
                align: 'left',
                sortable: false,
                isCurrency: true,
            },
            {
                text: 'PROMO TYPE',
                value: 'promoType',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DISCOUNT / FREEBIES',
                value: 'value',
                align: 'left',
                sortable: false,
                isCurrency: true,
            },
            {
                text: 'ACTIVE',
                value: 'active',
                align: 'left',
                sortable: false,
                switchable: true,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
        ];
    }
    isDiscount(promoType) {
        return promoType === PromoType.discount;
    }
    mounted() {
        this.viewCartPromosPage();
    }
};
CartPromos = __decorate([
    Component({
        components: {
            PageTitle,
            CartPromoManager,
            ActionButton,
        },
    })
], CartPromos);
export default CartPromos;
